export default __webpack_public_path__ + "static/media/post1.35b11635.txt";